import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const CLUBS = {
  ROOT: `${PRIVATE_ROOT}/community/clubs`,
  MY_CLUBS: `${PRIVATE_ROOT}/community/clubs/my-club`,
}
export const ADD_CLUB = `${PRIVATE_ROOT}/community/clubs/add-club`

export const VIEW_CLUB = `${PRIVATE_ROOT}/community/clubs/view-club/:id`
